import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { useIsDesktop } from '@edge/spark/ui-mui'

import DesktopNav from './DesktopNav'
import MobileNav from './MobileNav'

const isEditableTarget = (target: EventTarget | null) => {
    if (!(target instanceof HTMLElement)) {
        return false
    }

    const tagName = target.tagName.toLowerCase()

    return tagName === 'input' || tagName === 'textarea' || tagName === 'select' || target.isContentEditable
}

const NavBar: React.FC<RouteComponentProps> = ({ location }: RouteComponentProps) => {
    const [searchText, setSearchText] = React.useState('')
    const [auctionPickerOpenRequest, setAuctionPickerOpenRequest] = React.useState(0)
    const desktop = useIsDesktop()

    React.useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.repeat || isEditableTarget(event.target)) {
                return
            }

            const hasSupportedModifier = event.ctrlKey || event.metaKey

            if (!hasSupportedModifier || event.altKey || event.shiftKey || event.code !== 'Semicolon') {
                return
            }

            event.preventDefault()
            setAuctionPickerOpenRequest((currentValue) => currentValue + 1)
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    if (desktop) {
        return (
            <DesktopNav
                auctionPickerOpenRequest={auctionPickerOpenRequest}
                setSearchText={setSearchText}
                searchText={searchText}
            />
        )
    }
    return (
        <MobileNav
            auctionPickerOpenRequest={auctionPickerOpenRequest}
            pathname={location.pathname}
            searchText={searchText}
            setSearchText={setSearchText}
        />
    )
}

export default withRouter(NavBar)
